import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import _cloneDeepWith from 'lodash-es/cloneDeepWith';
import {catchError, map, Observable, of} from 'rxjs';
import {IEmpProfile, ILoginResult} from "@interface/model/login-info";
import {baseUrl} from "@config/base-url";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  router = inject(Router);
  private empUser: IEmpProfile | null = null;
  constructor(private http: HttpClient) {
  }
  public savedEmpUserInfo(): IEmpProfile | null {
    return this.empUser;
  }
  signOut() {
    return this.http.post<ILoginResult>(`${baseUrl}/api/AdmAuth/logout`, {});
  }
  signIn(loginId: string, password: string) {
    return this.http.post<ILoginResult>(`${baseUrl}/api/AdmAuth/login`,{
      loginId: loginId,
      password: password,
    },);
  }
  public empProfile():Observable<IEmpProfile> {
    return this.http.get<IEmpProfile>(`${baseUrl}/api/AdmAuth/profile`);
  }
  // public isEmpFindLevel(): boolean {
  //   const rndString = this.empUser?.Random;
  //   if (!rndString) return false;
  //   const rndArray = rndString.split(";");
  //   if(!Array.isArray(rndArray) || rndArray.length !== 20) return false;
  //   const ddInt = parseInt(rndArray[4]);
  //   if(isNaN(ddInt)) return false;
  //   return ddInt === 1;
  // }
  public isLabor(): boolean {
    return this.empUser?.Tree1 ?? false;
  }
  public isMaster(): boolean {
    // const rndString = this.empUser?.Tree5;
    // if (!rndString) return false;
    // const rndArray = rndString.split(";");
    // if(!Array.isArray(rndArray) || rndArray.length !== 20) return false;
    // const ddInt = parseInt(rndArray[7]);
    // if(isNaN(ddInt)) return false;
    return this.empUser?.Tree5 ?? false;
  }
  isLoggedIn() {
    return this.empProfile().pipe(
      map((user: IEmpProfile) => {
        // let values = x.token.split(";");
        // let thirdElement = values[2];  // 배열은 0부터 시작한다는 사실을 잊지 마세요.
        this.empUser = _cloneDeepWith(user);
        return true;
      }),
      catchError((_) => {
        // return of(false)
        // ['/admin/login']
        // return of(this.router.parseUrl('admin/login'));
        return of(this.router.createUrlTree(['login']));
      })
    );
  }
}
